export const ComputedOperators = {
    ADD: "+",
    SUB: "-",
    MUL: "*",
    DIV: "/",
    POW: "**",
    MOD: "%",
    LSHIFT: "<<",
    RSHIFT: ">>",
    AND: "&",
    OR: "|",
    XOR: "^",
    MAX: "max",
    MIN: "min",
    ADD_ZEROS: "*(10**X)",
    SUB_ZEROS: "/(10**X)",
    HASH: "keccak256",
};
//# sourceMappingURL=computedConstants.js.map